export const DEPRECIATION = {
  floor_value_eur: 100,
  initial_used_factor: 0.90,
  age: {
    max_age_years: 30,
    midpoint_years: 17,
    power_early: 0.9,
    power_late: 1.8,
    steepness: 8,
  },
  jumps: {
    horizon_jumps: 2500,
    midpoint_jumps: 1000,
    power_early: 0.9,
    power_late: 1.8,
    steepness: 8,
  },
  combination: {
    method: 'worse_dominant',
    secondary_weight: 0.3,
  },
  lineset: {
    reline_cost_eur: 609,
    reline_horizon_jumps: 300,
    weight: 0.50,
  },
};

export const ADJUSTMENTS = {
  version_penalty: {
    'safire-2':    0.88,
    'crossfire-2': 0.88,
    'crossfire':   0.80,
    'safire':      0.80,
    'sabre-2':     0.92,
    'velocity':    0.95,
    'epicene-pro': 0.93,
    'epicene':     0.85,
    'pilot':       0.96,
    'magellan':    0.93,
    'odyssey':     0.93,
    'skipper':     0.93,
    _default:      1.0,
  },
  brand_attractiveness: {
    jyro: {
      'safire-4':    1.08,
      'safire-3':    1.05,
      'crossfire-3': 1.08,
      'jfx2':        1.08,
      'leia':        1.05,
      'sleia':       1.05,
      'petra':       1.05,
      'kraken':      1.03,
      _default:      1.0,
    },
    'performance-designs': {
      'sabre-3':       1.08,
      'sabre-2':       1.05,
      'katana':        1.05,
      'valkyrie':      1.03,
      'comp-velocity': 1.03,
      _default:        1.0,
    },
    'fluid-wings': {
      'gangster':  1.05,
      'echo':      1.03,
      'airwolf-2': 1.03,
      'hk2':       1.03,
      'hk3':       1.03,
      _default:    1.0,
    },
    'aerodyne-research': {
      'pilot':   1.0,
      _default:  0.98,
    },
    squirrel: {
      _default: 1.0,
    },
    'icarus-world': {
      _default: 1.0,
    },
    skylark: {
      _default: 0.95,
    },
    paratec: {
      'scorpion': 1.0,
      'xtc':      1.0,
      _default:   0.98,
    },
    'precision-aerodynamics': {
      _default: 0.98,
    },
    _default_manufacturer: 1.0,
    _unknown_manufacturer: 0.92,
  },
  size: {
    tiers: [
      { above: 220, penalty: 0.80, label: 'very large (>220 sqft)' },
      { above: 190, penalty: 0.85, label: 'large (>190 sqft)' },
      { below: 80,  penalty: 0.93, label: 'very small (<80 sqft)' },
      { below: 100, penalty: 0.96, label: 'small (<100 sqft)' },
    ],
  },
};

export const MANUFACTURERS = {
  'performance-designs': {
    brand_key: 'performance-designs',
    models: {
      'navigator':     { new_price_eur: 2262 },
      'pulse':         { new_price_eur: 2523 },
      'silhouette':    { new_price_eur: 2540 },
      'spectre':       { new_price_eur: 2540 },
      'storm':         { new_price_eur: 2540 },
      'sabre-2':       { new_price_eur: 2601 },
      'sabre-3':       { new_price_eur: 2601 },
      'lightning':     { new_price_eur: 2601 },
      'horizon':       { new_price_eur: 2523 },
      'zero':          { new_price_eur: 2784 },
      'stiletto':      { new_price_eur: 2828 },
      'katana':        { new_price_eur: 2828 },
      'cf-storm':      { new_price_eur: 2871 },
      'velocity':      { new_price_eur: 2871 },
      'comp-velocity': { new_price_eur: 3106 },
      'valkyrie':      { new_price_eur: 3698 },
      'peregrine':     { new_price_eur: 3915 },
    },
  },
  jyro: {
    brand_key: 'jyro',
    models: {
      'air':         { new_price_eur: 2340 },
      'helium':      { new_price_eur: 2688 },
      'kraken':      { new_price_eur: 2601 },
      'safire-2':    { new_price_eur: 2253 },
      'safire-3':    { new_price_eur: 2253 },
      'safire-4':    { new_price_eur: 2688 },
      'crossfire-2': { new_price_eur: 2775 },
      'crossfire-3': { new_price_eur: 2775 },
      'jfx2':        { new_price_eur: 3123 },
      'leia':        { new_price_eur: 3645 },
      'petra':       { new_price_eur: 4254 },
      'sleia':       { new_price_eur: 4930 },
      'tandem':      { new_price_eur: 4254 },
      'element':     { new_price_eur: 2340 },
      'lazy-lover':  { new_price_eur: 2340 },
    },
  },
  'fluid-wings': {
    brand_key: 'fluid-wings',
    models: {
      'prime':     { new_price_eur: 2562 },
      'gangster':  { new_price_eur: 2997 },
      'echo':      { new_price_eur: 2997 },
      'airwolf-2': { new_price_eur: 3911 },
      'saw':       { new_price_eur: 3867 },
      'hk2':       { new_price_eur: 3998 },
      'hk3':       { new_price_eur: 4041 },
      'helix':     { new_price_eur: 3911 },
    },
  },
  'aerodyne-research': {
    brand_key: 'aerodyne-research',
    models: {
      'pilot':     { new_price_eur: 2401 },
      'pilot-7':   { new_price_eur: 2401 },
      'solo':      { new_price_eur: 2393 },
      'triathlon': { new_price_eur: 2306 },
      'zulu-x':    { new_price_eur: 2610 },
      'zulu':      { new_price_eur: 2610 },
      'a2':        { new_price_eur: 3915 },
    },
  },
  squirrel: {
    brand_key: 'squirrel',
    models: {
      'epicene-pro-2': { new_price_eur: 2545 },
      'omicron':       { new_price_eur: 2545 },
      'epicene-pro':   { new_price_eur: 2545 },
      'epicene':       { new_price_eur: 2545 },
    },
  },
  'icarus-world': {
    brand_key: 'icarus-world',
    models: {
      'equinox':     { new_price_eur: 2262 },
      'om-7':        { new_price_eur: 2567 },
      'omni':        { new_price_eur: 2540 },
      's-fire':      { new_price_eur: 2601 },
      'x-fire':      { new_price_eur: 2828 },
      'sky':         { new_price_eur: 2567 },
      'crossfire-2': { new_price_eur: 2828 },
    },
  },
  skylark: {
    brand_key: 'skylark',
    models: {
      'commodore':    { new_price_eur: 1436 },
      'magellan':     { new_price_eur: 1479 },
      'magellan-evo': { new_price_eur: 1610 },
      'odyssey':      { new_price_eur: 1479 },
      'odyssey-evo':  { new_price_eur: 1653 },
      'scirocco':     { new_price_eur: 1740 },
      'skipper':      { new_price_eur: 1479 },
      'skipper-evo':  { new_price_eur: 1566 },
      'chinook-evo':  { new_price_eur: 3132 },
    },
  },
  'precision-aerodynamics': {
    brand_key: 'precision-aerodynamics',
    models: {
      'fusion-2': { new_price_eur: 2513 },
      'nitron-2': { new_price_eur: 2567 },
      'xaos-21':  { new_price_eur: 2567 },
      'xaos-27':  { new_price_eur: 2567 },
    },
  },
  paratec: {
    brand_key: 'paratec',
    models: {
      'scorpion': { new_price_eur: 3087 },
      'xtc':      { new_price_eur: 3590 },
      'element':  { new_price_eur: 2444 },
    },
  },
  atair: {
    brand_key: 'atair',
    models: {
      'winx':  { new_price_eur: 2290 },
      'demon': { new_price_eur: 2290 },
      'cobalt': { new_price_eur: 2290 },
    },
  },
  'parachutes-de-france': {
    brand_key: 'parachutes-de-france',
    models: {
      'electra': { new_price_eur: 2500 },
      'springo': { new_price_eur: 2200 },
    },
  },
  'parachute-systems': {
    brand_key: 'parachute-systems',
    models: {
      'hurricane': { new_price_eur: 2175 },
    },
  },
  firebird: {
    brand_key: 'firebird',
    models: {
      'exit-1': { new_price_eur: 2500 },
    },
  },
};
